import { render, staticRenderFns } from "./pro-tree.vue?vue&type=template&id=5a4e17c9&scoped=true";
import script from "./pro-tree.vue?vue&type=script&lang=js";
export * from "./pro-tree.vue?vue&type=script&lang=js";
import style0 from "./pro-tree.vue?vue&type=style&index=0&id=5a4e17c9&prod&lang=less&scoped=true";

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js";
var component = normalizer(script, render, staticRenderFns, false, null, "5a4e17c9", null);
export default component.exports;